import { sortBy, uniqBy } from "lodash";
import { DimensionCutoff } from "../../../psyEvaluations.types";
import { RowDimension, ScoresColumn } from "../scoresTable.types";
import { getMatchedColor } from "../scoresTableUtils";

export const defaultLegendColumn: ScoresColumn = {
	id: "legend",
	isVisible: (context) => buildLegendItems(context.rowsDimensions).length > 0,
	getHeader: () => ({ label: "Legenda" }),
	getCell: (_row, rowIndex, context) => {
		if (rowIndex !== 0) return null;
		const legendItems = buildLegendItems(context.rowsDimensions);
		const entries = legendItems.map((cutoff) => ({
			key: buildLegendDedupeKey(cutoff),
			swatchColor: getMatchedColor(cutoff, context.levelColors),
			description: cutoff.description ?? "",
		}));
		return { rowSpan: context.rowsDimensions.length, content: { type: "legend", entries, entryAlign: "center" } };
	},
};

const buildLegendDedupeKey = (cutoff: DimensionCutoff) => {
	const dedupeKey = `${cutoff.level ?? ""}__${cutoff.description ?? ""}`;
	return dedupeKey;
};

const buildLegendItems = (rowsDimensions: Array<RowDimension>) => {
	const matchedCutoffs = rowsDimensions
		.map((row) => row.matchedCutoff)
		.filter((cutoff): cutoff is DimensionCutoff => cutoff != null);
	const uniqueCutoffs = uniqBy(matchedCutoffs, buildLegendDedupeKey);
	const legendItems = sortBy(uniqueCutoffs, (cutoff) => Number(cutoff.value_min));
	return legendItems;
};
